/** @format */

export const CurrencyHelper = {
    numericToStandardPln(amount, precision = 2, round = true, separator = ',') {
        if (!amount) {
            return `0${separator}00`;
        }

        let tmpAmount = amount;
        if (round) {
            let roundValue = '0'.repeat(precision);
            roundValue = '1' + roundValue;
            tmpAmount = (amount * roundValue) / roundValue;
        }
        const tmpVal = parseFloat(tmpAmount).toFixed(precision);
        if (separator !== ',') {
            return tmpVal;
        }
        return tmpVal.replace('.', ',');
    },

    numericToFloat(amount, separator = ',') {
        if (!amount) {
            return 0.0;
        }

        if (typeof amount === number) {
            return amount;
        }

        return parseFloat(amount.replace(',', '.'));
    },

    bulletproofRound(num, scale = 16) {
        if (!('' + num).includes('e')) {
            return +(Math.round(num + 'e+' + scale) + 'e-' + scale);
        } else {
            const arr = ('' + num).split('e');
            let sig = '';
            if (+arr[1] + scale > 0) {
                sig = '+';
            }
            let i = +arr[0] + 'e' + sig + (+arr[1] + scale);
            const j = Math.round(i);
            const k = +(j + 'e-' + scale);
            return k;
        }
    },
};
